"use client"
// PC 首页「热门内容」封面墙：推荐游戏（is_recommended，≤8 款）由服务端读库经 props 传入；
// 封面按中文名取 gamelistpic2 图（与 gamelist2 同规则），标题/链接文案经 dict 注入（默认中文）
import React from 'react'
import EmblaCarousel from './EmblaCarousel';
import { BlurFade } from './BlurFade'
import { homeDict, type HomeSection2Dict } from '@/lib/i18n/dicts/home'
import type { LocalizedGame } from '@/lib/game-i18n'
import { gameCover } from '@/lib/game-i18n'

// 中文文件名必须编码，否则 SSR 预加载进入 HTTP Link 响应头时会触发 ByteString 报错
const enc = (u: string) => encodeURI(u)

// 封面：后台上传的列表图（/media/）优先，否则按中文名取 gamelistpic2 默认封面（lib/game-i18n.gameCover）
const coverFor = gameCover

export interface Section2Props {
    dict?: HomeSection2Dict
    // 推荐游戏（localizedGames 处理过）；为空时整块不渲染
    games?: LocalizedGame[]
}

export default function Section2({ dict = homeDict.zh.section2, games = [] }: Section2Props) {
    if (games.length === 0) return null

    const items = games.map((game) => (
        <div key={game.gameid} className='flex'>
            <div className="group relative w-full cursor-pointer overflow-hidden rounded-xl bg-slate-200 ring-1 ring-black/5 transition-shadow duration-300 hover:shadow-xl hover:shadow-indigo-500/15">
                <a href={`../gamedetail2/${game.gameid}`}>
                    <img
                        alt={game.name}
                        loading="lazy"
                        onError={(e) => { e.currentTarget.src = game.imageUrl }}
                        className="aspect-[4/3] w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                        src={enc(coverFor(game))}
                    />
                    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                    <div className="absolute inset-x-0 bottom-0 translate-y-3 p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                        <p className="text-base font-bold text-white">{game.name}</p>
                        <p className="mt-1 text-xs leading-5 text-white/80 line-clamp-2">
                            {game.一句话描述 || game.游戏简介}
                        </p>
                    </div>
                </a>
            </div>
        </div>
    ));

    return (
        <>
            <main className="py-10 bg-slate-50">
                <div className="max-w-7xl space-y-3  mx-auto  px-8 ">
                    <BlurFade delay={0.1} inView>
                        <EmblaCarousel className="mb-6" products={items} title={dict.title} pageSize={5} />
                    </BlurFade>
                    <BlurFade delay={0.18} inView>
                        <div className="flex justify-center pt-2">
                            <a
                                href="../gamelist2"
                                className="inline-flex items-center gap-1.5 rounded-full bg-indigo-600 px-8 py-3 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-indigo-500 hover:shadow-xl hover:shadow-indigo-500/30"
                            >
                                {dict.viewAll}
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                                </svg>
                            </a>
                        </div>
                    </BlurFade>
                </div>
            </main>
        </>
    )
}
